import { get } from 'lodash'

export default {
  data() {
    return {
      loading: true,
      completed: false,
    }
  },
  computed: {
    binds() {
      return this.$get('binds', this.rawSqlNamespace)
    },
  },
  methods: {
    async resetBindValues() {
      for (const [bindName, bind] of Object.entries(this.binds)) {
        const isNull = get(bind, 'defaultIsNull', false)
        this.setBindValue(bindName, isNull ? null : get(bind, 'default'))
      }
    },
    setBindValue(bindName, value) {
      this.$dispatch('setBindValue', { bindName, value }, this.rawSqlNamespace)
    },
  },
}
